import { render, staticRenderFns } from "./CatalogDetail.vue?vue&type=template&id=2526edce&"
import script from "./CatalogDetail.vue?vue&type=script&lang=js&"
export * from "./CatalogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports